import script from "./SampleCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SampleCard.vue?vue&type=script&setup=true&lang=js"

import "./SampleCard.vue?vue&type=style&index=0&id=03b60848&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-03b60848"]])

export default __exports__